import { createInvitationStore } from "@/app/settings/club/components/invitation/store"
import { InvitationDialogProps } from "@/app/settings/club/components/invitation/type"
import BasicButton from "@/components/button/BasicButton"
import Dialog from "@/components/dialog/Dialog"
import { useTranslation } from "react-i18next"

import "./invitationResultDialog.scss"

export default function InvitationResultDialog({ open, onClose }: InvitationDialogProps) {
  const { t } = useTranslation("")

  const { invitationTotalEmailList, invitationErrorEmailList } = createInvitationStore((state) => ({
    invitationTotalEmailList: state.invitationTotalEmailList,
    invitationErrorEmailList: state.invitationErrorEmailList,
  }))

  return (
    <Dialog
      open={open}
      title={t("invitationResult")}
      onClose={onClose}
      maxWidth="600px"
      footer={
        <BasicButton onClick={onClose} type="default-outlined" size="md" className="dialog-confirm">
          {t("button.close")}
        </BasicButton>
      }>
      <div className="InvitationResultDialogCont">
        <p className="result-overview">
          {t("messages.inviteEmailsResult", {
            totalInviteEmails: invitationTotalEmailList.length,
            successInviteEmails: invitationTotalEmailList.length - invitationErrorEmailList.length,
          })}
        </p>

        {invitationErrorEmailList.length > 0 && (
          <div className="error-emails">
            <p className="error-emails-title">{invitationErrorEmailList.length} Failed</p>
            <div className="error-emails-list">
              {invitationErrorEmailList.map((email, index) => (
                <p key={index} className="error-email">
                  {email}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  )
}
